import { render, staticRenderFns } from "./AccountMunicipalityDetails.vue?vue&type=template&id=06d218e7&"
import script from "./AccountMunicipalityDetails.vue?vue&type=script&lang=js&"
export * from "./AccountMunicipalityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports